<script>
  import Employes from "../components/Personneliste.svelte";
</script>

<div id="liste"><Employes /></div>
